import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useState, useMemo, useEffect, useContext, createContext } from 'react';
import isEqual from "lodash/isEqual";
import { AuthService } from '@okta/okta-react';
import { fetchUserInfo } from './fetchUserInfo';
export const AuthStateContext = createContext(undefined);
export const useAuthState = () => useContext(AuthStateContext);
function convertAuthState(state) {
  const isAuthenticated = state.isAuthenticated,
    isPending = state.isPending,
    accessToken = state.accessToken,
    idToken = state.idToken,
    error = state.error;
  const newState = {
    isAuthenticated: !!isAuthenticated,
    isPending: !!isPending,
    accessToken,
    idToken,
    userInfo: null
  };
  if (error) {
    newState.error = error;
  }
  return newState;
}
export const AuthStateProvider = _ref => {
  let children = _ref.children,
    authServiceProp = _ref.authService,
    props = _objectWithoutProperties(_ref, ["children", "authService"]);
  const authService = useMemo(() => authServiceProp || new AuthService(props), [authServiceProp]);
  const _useState = useState(() => convertAuthState(authService.getAuthState())),
    _useState2 = _slicedToArray(_useState, 2),
    authState = _useState2[0],
    setAuthState = _useState2[1];
  useEffect(() => {
    let hasEffectChange = false;
    const unsubscribe = authService.on('authStateChange', () => {
      const newState = convertAuthState(authService.getAuthState());
      const isAuthenticated = newState.isAuthenticated,
        accessToken = newState.accessToken;
      if (!isAuthenticated || !accessToken) {
        setAuthState(oldState => {
          if (isEqual(oldState, newState)) {
            return oldState;
          }
          return newState;
        });
        return;
      }
      const loadAuthData = async () => {
        const idToken = await authService._oktaAuth.tokenManager.get('idToken');
        const userInfo = idToken ? idToken.claims : await fetchUserInfo(accessToken);
        if (hasEffectChange) {
          return;
        }
        setAuthState(_objectSpread({}, newState, {
          userInfo
        }));
      };
      loadAuthData();
    });
    authService.updateAuthState();
    return () => {
      hasEffectChange = true;
      unsubscribe();
    };
  }, [authService]);
  return React.createElement(AuthStateContext.Provider, {
    value: {
      authService,
      authState
    }
  }, children);
};
AuthStateProvider.__docgenInfo = {
  componentName: "AuthStateProvider",
  packageName: "@jutro/auth",
  description: "Initiate Okta's AuthService and store auth state\nSimilar to okta-react's Secure component",
  displayName: "AuthStateProvider",
  methods: [],
  actualName: "AuthStateProvider"
};